import React, {useEffect, useRef, useState} from 'react';
import {BackToFirstStepBtn} from "./login.styles";
import {TextInput, Alert} from "../../core-ui";
import gsap from "gsap";
import {Link, useNavigate} from "react-router-dom";
import {Jumbotron} from "../../core-ui/jumbotron/jumbotron";
import {fetchData, getMultiModeNumber} from "../../helpers/general-function";
import Notification from "../../helpers/notifications";
import {useDispatch} from 'react-redux';
import {setLoginStatus} from "../../redux/user/user.action";
import {PHARMA_TOK} from "../../helpers/general-variables";


const formParams = {
    mobile: '',
    verification_code: ''
};
const Login = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const firstStepRef = useRef(null);
    const secondStepRef = useRef(null);
    const timeRef = useRef(null);

    const [loginValues, setLoginValues] = useState(formParams);
    const [isValidResendCode, setValidResendCode] = useState(false);
    const [timeInterval, setTimeInterval] = useState();

    useEffect(() => {
        return () => {
            clearInterval(timeInterval);
        }
    }, [timeInterval]);

    const changeHandler = ({target: {value, name}}) => {
        setLoginValues(prevStates => ({...prevStates, [name]: value}));
    }

    const sendMobile = async () => {

        // const isValidData = await isValidVerificationCode(verificationsValues.verification_code);
        // if (!isValidData) {
        //     return false;
        // }

        const data = await fetchData('login', 'post', {mobile: loginValues.mobile});

        if(data) {
            timeRef.current.innerText = `${getMultiModeNumber(Math.floor(data.remaining_time / 60))}:${getMultiModeNumber(Math.floor(data.remaining_time % 60))}`;
            setTimeInterval(setInterval(countDownHandler, 1000));
            changeStep(firstStepRef, secondStepRef);
        }
    }

    const sendVerificationCode = async () => {

        // const isValidData = await isValidVerificationCode(verificationsValues.verification_code);
        // if (!isValidData) {
        //     return false;
        // }

        const data = await fetchData('login/verify', 'post', loginValues);

        if(data) {
            localStorage.setItem(PHARMA_TOK, data.token);
            dispatch(setLoginStatus(true));
            Notification.success('با موفقیت وارد شدید');
            navigate('/');
        }
    }

    const resendCode = async () => {
        setValidResendCode(false);
        timeRef.current.innerText = '01:10';
        setTimeInterval(setInterval(countDownHandler, 1000));
        Notification.danger('coming soon ...');
        // const data = await fetchData('register/verify', 'post', verificationsValues);
    }

    const changeStep = (currentRef,targetRef) => {

        gsap.to(currentRef.current, .3, {
            opacity: 0,
            onComplete: () => {
                currentRef.current.classList.add('d-none');
                targetRef.current.classList.remove('d-none');
                targetRef.current.classList.add('d-flex');
                gsap.from(targetRef.current, .3, {
                    opacity: 0,
                    onComplete: () => {
                        // setActiveStep(2);
                    }
                })
            }
        })
    }

    const countDownHandler = () => {
        try {
            let live_time = timeRef.current.innerText;

            if (!live_time || live_time === "") return false;
            let [m, s] = live_time.split(":");

            m = parseInt(m)
            s = parseInt(s)

            if (s !== 0) {
                s--;
            } else {
                if (m !== 0) {
                    m--;
                    s = 59;
                } else {
                    clearInterval(timeInterval);
                    setTimeInterval(null);
                    setValidResendCode(true);
                }
            }

            timeRef.current.innerText = `${getMultiModeNumber(m)}:${getMultiModeNumber(s)}`;

        } catch (e) {
            console.log(e)
        }
    }

    return (
        <div className='container-md my-4'>
            <div className='d-flex justify-content-between align-items-center d-lg-none rtl mt-5 mb-3'>
                <h3 className='success-color fw-normal'>ورود به فارماکار</h3>
                <Link to='/sign-up' className='c-btn-outline-gray' style={{borderRadius: '7px'}}>ثبت نام داروساز</Link>
            </div>
            <Jumbotron>
                <div className='d-none d-lg-flex justify-content-between align-items-center'>
                    <h3 className='success-color fw-normal'>ورود به فارماکار</h3>
                    <Link to='/sign-up' className='c-btn-outline-gray'>ثبت نام داروساز</Link>
                </div>

                <div ref={firstStepRef} className='d-flex flex-column flex-grow-1'>
                    <div className='rtl mt-4 mt-lg-5 flex-grow-1 d-flex flex-column justify-content-between'>

                        <div className='d-flex align-items-center justify-content-center flex-grow-1 mt-3'>
                            <div className='text-center w-100 w-lg-auto'>
                                <p className='gray-color mb-2'>برای ورود به سامانه تلفن همراه خود را وارد کنید</p>
                                <p className='gray-color'>تا کد ورود به شما ارسال شود</p>
                                <div className='mt-5'>
                                    <TextInput placeholder='تلفن همراه' value={loginValues.mobile}
                                               onChange={changeHandler} classNames='rtl'
                                               iconName='icon-call' name='mobile'/>
                                </div>
                                <div className='d-flex justify-content-center mt-6'>
                                    <button className='c-btn c-btn-warning px-c-4 flex-grow-1 flex-lg-grow-0 py-c-2'
                                            onClick={sendMobile}>ارسال پیامک تایید</button>
                                </div>
                            </div>
                        </div>

                        <Link to='/' className='gray-color gray-hover d-none d-lg-inline-block' style={{marginRight: '-3rem'}}>
                            <i className='icon-arrow-circle-right align-middle ms-3' />
                            بازگشت به صفحه نخست
                        </Link>
                    </div>
                </div>

                <div ref={secondStepRef} className='d-none flex-column flex-grow-1'>
                    <div className='rtl mt-4 mt-lg-5 flex-grow-1 d-flex flex-column justify-content-between'>

                        <div className='d-flex align-items-center justify-content-center flex-grow-1 mt-3'>
                            <div className='text-center w-100 w-lg-auto'>
                                <p className='gray-color mb-2'>کلمه عبور به شما ارسال شد</p>

                                <div className='d-flex flex-column'>
                                    <div className='order-2 order-lg-1 mt-c-2_5 mt-lg-0'>
                                        <button className={`btn-text dark-gray ${isValidResendCode ? '' : 'd-none'}`}
                                                onClick={isValidResendCode ? resendCode : () => {}}>
                                            <i className='ms-2 icon-refresh'/>ارسال مجدد
                                        </button>

                                        <p className={`gray-color ${isValidResendCode ? 'd-none' : ''}`}>ارسال مجدد در
                                            <span ref={timeRef} className='d-inline-block me-2' style={{minWidth: '40px'}}>02:00</span>
                                        </p>
                                    </div>

                                    <div className='order-1 order-lg-2'>
                                        <div className='mt-lg-5 position-relative'>
                                            <TextInput placeholder='تلفن همراه' value={loginValues.mobile}
                                                       wrapperClassNames='d-none d-lg-block'
                                                       classNames='rtl' disabled='disabled' onChange={() => {}}
                                                       iconName='icon-call'/>

                                            <BackToFirstStepBtn className='btn-simple-text'
                                                                onClick={() => changeStep(secondStepRef, firstStepRef)}>تغییر شماره تلفن</BackToFirstStepBtn>

                                            <TextInput placeholder='کلمه عبور پیامک شده' value={loginValues.verification_code}
                                                       onChange={changeHandler}
                                                       wrapperClassNames='mt-c-2' classNames='rtl'
                                                       iconName='icon-lock' name='verification_code'/>
                                        </div>
                                    </div>
                                </div>

                                <div className='mt-5 mt-c-lg-7 d-flex justify-content-center'>
                                    <button className='c-btn c-btn-warning flex-grow-1 flex-lg-grow-0 py-c-2'
                                            onClick={sendVerificationCode}>ورود به سامانه</button>
                                </div>
                            </div>
                        </div>

                        <Link to='/' className='gray-color gray-hover d-none d-lg-inline-block' style={{marginRight: '-3rem'}}>
                            <i className='icon-arrow-circle-right align-middle ms-3' />
                            بازگشت به صفحه نخست
                        </Link>
                    </div>
                </div>
            </Jumbotron>
        </div>
    );
};

export default Login;
